import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=ce78165a"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce78165a')) {
      api.createRecord('ce78165a', component.options)
    } else {
      api.reload('ce78165a', component.options)
    }
    module.hot.accept("./Tag.vue?vue&type=template&id=ce78165a", function () {
      api.rerender('ce78165a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/content/Tag.vue"
export default component.exports